import i18n from 'i18nextInstance';

export const NOTIFICATIONS = [{
    flex: 2,
    key: 'type',
    label: i18n.t('Tipo')
}, {
    flex: 3,
    key: 'template_label',
    label: i18n.t('Template')
}, {
    key: 'enabled_label',
    label: i18n.t('Habilitado')
}, {
    key: 'start_time',
    label: i18n.t('Inicio')
}, {
    key: 'end_time',
    label: i18n.t('Fin')
}, {
    key: 'mean',
    label: i18n.t('Medio')
}, {
    key: 'prev_minutes',
    label: i18n.t('Min Previos')
}, {
    key: 'doctor_label',
    label: i18n.t('Profesional')
}, {
    key: 'specialty_label',
    label: i18n.t('Especialidad')
}];

export const TEMPLATES = [{
    key: 'name',
    label: i18n.t('Nombre')
}, {
    flex: 2,
    key: 'subject',
    label: i18n.t('Asunto')
}];
